import React from 'react';
import { BarChart3, Users, Ticket, Settings } from 'lucide-react';

const Sidebar = ({ activeTab, onTabChange }) => {
  const menuItems = [
    {
      id: 'dashboard',
      name: '대시보드',
      icon: BarChart3
    },
    {
      id: 'couponHistory',
      name: '쿠폰 사용 내역',
      icon: Ticket
    },
    {
      id: 'customers',
      name: '고객 관리',
      icon: Users
    },
    {
      id: 'settings',
      name: '매장 설정',
      icon: Settings
    }
  ];

  return (
    <nav className="lg:w-64 space-y-2">
      {menuItems.map((item) => {
        const Icon = item.icon;
        return (
          <button
            key={item.id}
            onClick={() => onTabChange(item.id)}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-colors ${
              activeTab === item.id
                ? 'bg-blue-100 text-blue-700'
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            <Icon className="w-5 h-5" />
            <span>{item.name}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default Sidebar;